@if (entry.base?.display) {
  <!-- Houses dynamically updated stringified data-->
  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"></form>
  @if (bankForm && creditCardForm) {
    <form class="banking-form" [hidden]="!showBankForm" [formGroup]="bankForm" (ngSubmit)="submit()">
      <h2>PAY BY BANK ACCOUNT</h2>
      <h3>Please enter your bank account information to complete payment.</h3>
      <!-- Routing Number -->
      <mat-form-field appearance="outline">
        <mat-label>Routing Number</mat-label>
        <input matInput formControlName="routingNumber" [placeholder]="'9999999999'"/>
        @if (bankFormControls.routingNumber.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <!-- Account Number -->
      <mat-form-field appearance="outline">
        <mat-label>Account Number</mat-label>
        <input matInput formControlName="accountNumber" [placeholder]="'2222222222222'" [type]="isAccountNumberVisible ? 'text' : 'password'" autocomplete="new-password"/>
        <span matSuffix class="material-symbols-outlined" [title]="isAccountNumberVisible ? 'Hide' : 'Show'" (click)="isAccountNumberVisible = !isAccountNumberVisible">
          {{isAccountNumberVisible ? 'visibility_off' : 'visibility' }}
        </span>
        @if (bankFormControls.accountNumber.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <!-- Primary Name On Account -->
      <mat-form-field appearance="outline">
        <mat-label>Primary Name On Account</mat-label>
        <input matInput formControlName="primaryNameOnAccount" [placeholder]="'Full Name'"/>
        @if (bankFormControls.primaryNameOnAccount.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <h4>Billing Address</h4>
      <div formGroupName="billingAddress">
        <!-- Address Line 1 -->
        <mat-form-field appearance="outline">
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" [placeholder]="'Address Line 1'"/>
          @if (bankFormBillingAddressControls.addressLine1.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- Address Line 2 -->
        <mat-form-field appearance="outline">
          <mat-label>Address Line 2 ( Optional )</mat-label>
          <input matInput formControlName="addressLine2" [placeholder]="'Address Line 2 ( Optional )'"/>
          @if (bankFormBillingAddressControls.addressLine2.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- City -->
        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" [placeholder]="'City'"/>
          @if (bankFormBillingAddressControls.city.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- State Abbreviation -->
        <mat-form-field appearance="outline">
          <mat-label>State (2-letter abbreviation)</mat-label>
          <input matInput formControlName="state" [placeholder]="'State (2-letter abbreviation)'" (change)="forceStateToUpperCase(bankForm)"/>
          @if (bankFormBillingAddressControls.state.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- Zip Code -->
        <mat-form-field appearance="outline">
          <mat-label>Zip Code</mat-label>
          <input matInput formControlName="zipcode" [placeholder]="'Zip Code'"/>
          @if (bankFormBillingAddressControls.zipcode.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="button-container">
        <div class="nav-link">
          <a href="javascript:void(0)" (click)="goBack()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">BACK</span>
          </a>
        </div>
        <button mat-raised-button color="primary" type="submit">Submit Payment</button>
      </div>
    </form>
    <form class="credit-card-form" [hidden]="!showCreditCardForm" [formGroup]="creditCardForm" (ngSubmit)="submit()">
      <h2>PAY BY CREDIT CARD</h2>
      <h3>Please enter your credit/debit card information to complete payment.</h3>
      <!-- Type Of Card -->
      <mat-form-field appearance="outline">
        <mat-label>Type Of Card</mat-label>
        <mat-select aria-label="Type Of Card" formControlName="ccType" [placeholder]="'Type Of Card'">
          @for (type of cardTypeOptions; track trackByIndex($index, type)) {
            <mat-option [value]="type.value">
              {{type.label}}
            </mat-option>
          }
        </mat-select>
        @if (creditCardFormControls.ccType.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <!-- Credit Card Number -->
      <mat-form-field appearance="outline">
        <mat-label>Credit Card Number</mat-label>
        <input matInput formControlName="ccNumEnc" [placeholder]="'Credit Card / Debit Card'" [type]="isCreditCardNumberVisible ? 'text' : 'password'" autocomplete="new-password"/>
        <span matSuffix class="material-symbols-outlined" [title]="isCreditCardNumberVisible ? 'Hide' : 'Show'" (click)="isCreditCardNumberVisible = !isCreditCardNumberVisible">
          {{isCreditCardNumberVisible ? 'visibility_off' : 'visibility' }}
        </span>
        @if (creditCardFormControls.ccNumEnc.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <!-- CC Expiration Month -->
      <mat-form-field appearance="outline">
        <mat-label>CC Expiration Month</mat-label>
        <input matInput formControlName="ccExpDtMonth" [placeholder]="'CC Expiration Month'"/>
        @if (creditCardFormControls.ccExpDtMonth.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <!-- CC Expiration Year -->
      <mat-form-field appearance="outline">
        <mat-label>CC Expiration Year</mat-label>
        <input matInput formControlName="ccExpDtYear" [placeholder]="'CC Expiration Year'"/>
        @if (creditCardFormControls.ccExpDtYear.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <!-- Name On Card -->
      <mat-form-field appearance="outline">
        <mat-label>Name On Card</mat-label>
        <input matInput formControlName="name" [placeholder]="'Name On Card'"/>
        @if (creditCardFormControls.name.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
      <h4>Billing Address</h4>
      <div formGroupName="billingAddress">
        <!-- Address Line 1 -->
        <mat-form-field appearance="outline">
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" [placeholder]="'Address Line 1'"/>
          @if (creditCardFormBillingAddressControls.addressLine1.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- Address Line 2 -->
        <mat-form-field appearance="outline">
          <mat-label>Address Line 2 ( Optional )</mat-label>
          <input matInput formControlName="addressLine2" [placeholder]="'Address Line 2 ( Optional )'"/>
          @if (creditCardFormBillingAddressControls.addressLine2.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- City -->
        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" [placeholder]="'City'"/>
          @if (creditCardFormBillingAddressControls.city.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- State Abbreviation -->
        <mat-form-field appearance="outline">
          <mat-label>State (2-letter abbreviation)</mat-label>
          <input matInput formControlName="state" [placeholder]="'State (2-letter abbreviation)'" (change)="forceStateToUpperCase(creditCardForm)"/>
          @if (creditCardFormBillingAddressControls.state.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <!-- Zip Code -->
        <mat-form-field appearance="outline">
          <mat-label>Zip Code</mat-label>
          <input matInput formControlName="zipcode" [placeholder]="'Zip Code'"/>
          @if (creditCardFormBillingAddressControls.zipcode.errors?.required) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="button-container">
        <div class="nav-link">
          <a href="javascript:void(0)" (click)="goBack()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">BACK</span>
          </a>
        </div>
        <button mat-raised-button color="primary" type="submit">Submit Payment</button>
      </div>
    </form>
    <form class="bill-me-later-form" [hidden]="!showBillMeLaterForm" (ngSubmit)="submit()">
      <h2>SEND ME A BILL</h2>
      <h3>A bill will be sent to you for the amount of your first month's premium, payable by paper check, cashier's check or money order.</h3>
      <div class="dynamic-payment-data">
        @for (field of billMeLaterInfo; track trackByIndex($index, field)) {
          <p>
            <span class="bold-me">{{field.label}}:</span><br/><span [innerHTML]=field.value></span>
          </p>
        }
      </div>
      <div class="button-container">
        <div class="nav-link">
          <a href="javascript:void(0)" (click)="goBack()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">BACK</span>
          </a>
        </div>
        <button mat-raised-button color="primary" type="submit">Submit Payment</button>
      </div>
    </form>
  }
}
